
import styled from "styled-components";
import bg from "./images/new/BG.png";
import mbbg from "./images/new/mbBg.png";

const StyledApp = styled.div`
@font-face {
  font-family: "Century Gothic"; 
  src: url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.eot"); 
  src: url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.eot?#iefix") 
  format("embedded-opentype"), 
  url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.woff2") 
  format("woff2"), 
  url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.woff") 
  format("woff"), 
  url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.ttf") 
  format("truetype"), 
  url("//db.onlinewebfonts.com/t/0d78b12d6be09203d1fbeb76871a369a.svg#Century Gothic") 
  format("svg");
 }

  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column;

  //app background
  background-repeat: no-repeat;
  background-image: url(${bg});
  background-position: top center;
  background-size: 100% 28%;

  @media (max-width: 991px) {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-flow: column;
  
    //app background
    background-repeat: no-repeat;
    background-image: url(${mbbg});
    background-position: top center;
    background-size: 100% 13%;
  }

  
 
`;
export default StyledApp;
